import { createRouter, createWebHistory } from 'vue-router'
import { getAuth, onAuthStateChanged } from 'firebase/auth'

import Login from '../views/LoginView.vue'
import Dashboard from '../views/Dashboard.vue'
import Hello from '../views/HelloView.vue'
import TwoFactor from '../views/TwoFactor.vue'

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/2fa',
    name: 'TwoFactor',
    component: TwoFactor,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'DashboardView',
    component: Dashboard,
    meta: { requiresAuth: true, requires2FA: true }
  },
  {
    path: '/hello',
    name: 'Hello',
    component: Hello
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 🔐 Global navigation guard
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const requires2FA = to.matched.some(record => record.meta.requires2FA)

  const auth = getAuth()

  onAuthStateChanged(auth, (user) => {
    if (!requiresAuth) {
      next()
      return
    }

    if (!user) {
      next('/login')
    } else {
      const is2FAVerified = sessionStorage.getItem('2faVerified') === 'true'

      if (requires2FA && !is2FAVerified) {
        next('/2fa')
      } else {
        next()
      }
    }
  })
})

export default router